let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7pnGT")).then(() => parcelRequire('5KV6E'));